import { Card, Row, Col } from 'antd';
import { dataNotFound } from '../../../../constants';

export const DataNotFound = () => {
  return (
    <Row justify="center">
      <Col span={24}>
        <Card
          style={{
            width: '100%',
            minHeight: 200,
            marginTop: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <h2>{dataNotFound.noData}</h2>
        </Card>
      </Col>
    </Row>
  );
};
